import React from 'react'
import Popup from './Popup'
import PrimaryButton from './PrimaryButton'
import { LeaveIcon } from '../svgIcons/LeaveIcon'
import { OutgoingLinkIcon } from '../svgIcons/OutgoingLink'
import { CopyIcon } from '../svgIcons/CopyIcon'
import { BraavosLogo } from '../svgIcons/BraavosLogo'
import { addToastMsg } from '../services/amm'

// const Backdrop = styled('div')`
//     z-index: -1;
//     position: fixed;
//     right: 0;
//     bottom: 0;
//     top: 0;
//     left: 0;
//     background-color: rgba(0, 0, 0, 0.8);
//     -webkit-tap-highlight-color: transparent;
// `

function ConnectedWalletOptions(props: {
    setOpenConnectedOptions: (arg0: boolean) => void
    explorerUrl: string | URL | undefined
    disconnect: () => void
    walletAddress: string
    walletName: string
    walletIcon: string | undefined
}) {
    const handleClose = () => {
        props.setOpenConnectedOptions(false)
    }

    const openExplorer = async () => {
        window.open(props.explorerUrl, '_blank')
        props.setOpenConnectedOptions(false)
    }
    const disconnect = () => {
        props.disconnect()
        handleClose()
    }

    const shortAddress = () => {
        if (!props.walletAddress) return 'NO ACCOUNT'
        return props.walletAddress.substr(0, 12) + '...' + props.walletAddress.substr(-10)
    }

    return (
        <Popup title='Account' onClose={handleClose} open={true}>
            <>
                <span className='text-def font-bold mt-6 block'>Connected with {props.walletName}</span>
                {/* <Box py={2}> */}
                <div className='flex items-center w-full justify-between mt-6'>
                    <div className='flex items-center'>
                        {props.walletName.toLowerCase() === 'braavos' ? (
                            <BraavosLogo className='h-[36px] w-[36px]' />
                        ) : (
                            <img src={props.walletIcon} alt='' width='24' height='24' />
                        )}
                        <span className='ml-4'>{shortAddress()}</span>
                    </div>
                    <div
                        className='flex items-center text-[#0AE8F9] cursor-pointer'
                        onClick={() => {
                            navigator.clipboard.writeText(props.walletAddress)
                            addToastMsg('Copied address', '')
                        }}>
                        <span className='hidden lg:flex select-none ml-4'>Copy address</span>
                        <CopyIcon className='ml-4 w-[14px] h-[14px]' />
                    </div>
                    {/* <IconButton
                        onClick={() => {
                            navigator.clipboard.writeText(props.walletAddress)
                        }}>
                        <ContentCopyIcon style={{ color: 'white' }} />
                    </IconButton> */}
                </div>
                <div className='flex mt-6'>
                    <PrimaryButton onClick={disconnect} size='sm' theme='border' className='flex-1 border border-[1px] border-[#0C3F6D] mr-2'>
                        <div className='flex items-center'>
                            <span className='text-[12px] lg:text-[16px] text-white'>Disconnect</span>
                            <LeaveIcon className='ml-2 w-[14px] h-[14px]' />
                        </div>
                    </PrimaryButton>
                    <PrimaryButton onClick={openExplorer} size='sm' theme='border' className='flex-1 border border-[1px] border-[#0C3F6D]'>
                        <div className='flex items-center'>
                            <span className='text-[12px] lg:text-[16px] text-white'>View on Voyager</span>
                            <OutgoingLinkIcon className='ml-2 w-[14px] h-[14px]' />
                        </div>
                    </PrimaryButton>
                </div>
            </>
        </Popup>
    )
}

export default ConnectedWalletOptions
